import React from 'react'
import intl from 'react-intl-universal'
import Popup from 'react-popup'
import { connect } from 'react-redux'
import { selectShipping, getShipping, saveShipping, clearShippingData, getTransitRate, changeShippingCarrier } from '../actions/ShippingActions'

const extraFields = ['currency_id', 'receiver_country', 'sizes', 'types', 'carriers', 'shops', 'countries', 'show_transit_rate_on_packing_zone', 'options']

const mapStateToProps = state => ({
  shipping: state.shipping.shipping,
  shipping_data: state.shipping.shipping_data,
  order_id: state.router.location.query.order ? parseInt(state.router.location.query.order) : false,
  order: state.pack.order,
})

const mapDispatchToProps = dispatch => ({
  getShippingAction: (id, order_id) => dispatch(getShipping(id, order_id)),
  selectShippingAction: (id) => dispatch(selectShipping(id)),
  saveShippingAction: (id, data, order_id) => dispatch(saveShipping(id, data, order_id)),
  clearShippingData: () => dispatch(clearShippingData()),
  getTransitRateAction: (id, data, order_id) => dispatch(getTransitRate(id, data, order_id)),
  changeShippingCarrierAction: (id, rate, order_id) => dispatch(changeShippingCarrier(id, rate, order_id))
})

const addTmpIds = (parcels) => {
  return parcels.map((p, i) => {
    p.tmpid = `#${i+1}`
    return p
  })
}

class ShippingComponent extends React.Component {
  constructor(props) {
    super(props)
    const { shipping } = props
    this.state = {
      editMode: shipping === 0,
      newMode: shipping === 0,
      extraRows: [],
      deleteRows: [],
      selectedCarrier: false,
      saving: false,
      transitRateResult: null,
      transitRateLoading: false,
      transitRateExtraVals: {},
      transitRateConfirm: null
    }
  }

  componentDidMount() {
    const { shipping_id, getShippingAction, order_id } = this.props
    if(shipping_id !== false) getShippingAction(parseInt(shipping_id), order_id)
  }

  componentDidUpdate() {
    //domyślne paczki przerzucamy jako extraRows czyli nowo utworzone
    const { shipping, shipping_data } = this.props;
    const { extraRows, selectedCarrier, newMode } = this.state;

    const defaultCarrier = shipping_data.carrier_id;
    const carriers = shipping_data && shipping_data.carriers;
      
    if (!shipping_data || !carriers) {
      return;
    }

    const carrier = carriers.find(c => c.id === defaultCarrier);

    if (!carrier) {
      return;
    }

    const defaultParcels = carrier.default_parcels;

    if (
      shipping === 0 &&
      shipping_data &&
      carrier &&
      defaultParcels &&
      extraRows.length === 0
    ) {
      this.setState({
        extraRows: addTmpIds([defaultParcels])
      });
    }

    if (newMode && selectedCarrier === false && shipping_data && defaultCarrier) {
      this.setState({
        selectedCarrier: parseInt(defaultCarrier)
      })
    }
  }

  componentWillUnmount() {
    const { saving } = this.state
    const { clearShippingData } = this.props
    if(!saving){
      clearShippingData()
    }
  }

  deselectShipping = (event) => {
    const {selectShippingAction, parent} = this.props
    Popup.close()
    parent.shippingList()
    selectShippingAction(false)
  }

  buildFormData = () => {
    const { shipping_data } = this.props
    const { extraRows, deleteRows, newMode, transitRateExtraVals } = this.state
    let inputs = Array.from(document.querySelectorAll('.shipping input, .shipping select'))
    let diff = {}
    inputs.map(input => {
      let val = input.value
      if (input.tagName === 'SELECT' && !input.dataset.option){
        val = parseInt(val)
      }
      if(input.dataset.parcel){
        //paczki
        let parcel_id = parseInt(input.name.replace( /^\D+/g, ''))
        let parcel_tmpid = input.dataset.tmpid
        let field = input.name.split('_').splice(0, input.name.split('_').length-1).join('_')

        let parcel_found = shipping_data.shipping_parcels_ids.find(p => (p.id === parcel_id))
        if(!parcel_found){
          parcel_found = extraRows.find(p => (p.tmpid === parcel_tmpid))
        }
        if(!parcel_found){
          Popup.alert(intl.get('Wystąpił nieoczekiwany błąd. Odśwież stronę i spróbuj ponownie'))
        }
        if(typeof parcel_found.id === 'undefined' || (parcel_found[field] != val) || newMode){
          if(typeof diff.shipping_parcels_ids === 'undefined'){
            diff.shipping_parcels_ids = []
          }
          let parcel_diff = diff.shipping_parcels_ids.find(p => {
            return (p.id === parcel_id) || (p.tmpid === parcel_tmpid)
          })
          if(!parcel_diff){
            if(parcel_id){
              parcel_diff = {id: parcel_id}
            } else {
              parcel_diff = {tmpid: parcel_tmpid}
            }
            diff.shipping_parcels_ids.push(parcel_diff)
          }
          parcel_diff[field] = val
        }
        return true
      }
      if(input.dataset.option){
        //opcje i usługi z ideaerp_base (get_packing_zone_options)
        if(input.type === 'checkbox'){
          val = !!input.checked
        } else if(input.type === 'number'){
          val = input.value === '' ? 0 : parseFloat(input.value)
        }
        const option = (shipping_data.options || []).find(o => o.name === input.name)
        if(newMode || !option || val != option.value){
          diff.options = diff.options || {}
          diff.options[input.name] = val
        }
        return true
      }
      //zwykle pola
      if(input.type === 'checkbox'){
        val = !!input.checked
      }
      if((val != shipping_data[input.name]) || newMode){
        diff[input.name] = val
      }
      return true
    })
    if(newMode){
      diff['id'] = 0
      //pola z get_shipping_data, które nie mają swoich inputów
      Object.keys(shipping_data).filter((key) => {
        return (Object.keys(diff).indexOf(key) === -1) && (extraFields.indexOf(key) === -1)
      }).map(key => {
        diff[key] = shipping_data[key]
      })
      //pola ustawione przez wybór stawki tranzytu (np. innoship_service_type)
      Object.assign(diff, transitRateExtraVals)
    }
    if(deleteRows.length > 0){
      diff['parcel_delete'] = deleteRows
    }
    return diff
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { shipping_data, saveShippingAction, order_id } = this.props
    const diff = this.buildFormData()
    if(Object.keys(diff).length === 0){
      Popup.alert(intl.get('Nie znaleziono zmian'))
    }
    const parcelSizesInput = document.getElementById('parcelSizes');
    if (shipping_data.shipping_parcels_ids && Array.isArray(shipping_data.shipping_parcels_ids) && shipping_data.shipping_parcels_ids.length > 0) {
      const latestParcel = shipping_data.shipping_parcels_ids[shipping_data.shipping_parcels_ids.length - 1];
      const parcelSize = latestParcel.size[1];
      if (parcelSizesInput) {
        parcelSizesInput.value = parcelSize;
      }
    } else {
      if (parcelSizesInput) {
        parcelSizesInput.value = '';
      }
    }
    this.setState({saving: true})
    saveShippingAction(shipping_data.id, diff, order_id)
  }

  handleFetchTransitRate = (event) => {
    event.preventDefault()
    const { shipping_data, getTransitRateAction, order_id } = this.props
    const { newMode } = this.state
    const request = newMode
      ? getTransitRateAction(0, this.buildFormData(), order_id)
      : getTransitRateAction(shipping_data.id, null, order_id)
    this.setState({transitRateLoading: true})
    request.then(result => {
      this.setState({transitRateResult: {...result, error: false}})
    }).catch(error => {
      this.setState({transitRateResult: {rates: [], error: error.message}})
    }).finally(() => {
      this.setState({transitRateLoading: false})
    })
  }

  selectTransitRate = (rate) => {
    const { newMode } = this.state
    if (newMode) {
      //zostawiamy wpisane paczki - stawka była liczona dla nich
      this.setState({
        selectedCarrier: rate.carrier_id,
        transitRateExtraVals: rate.extra_vals || {},
        transitRateResult: null
      })
      return
    }
    this.setState({transitRateConfirm: rate})
  }

  confirmTransitRate = () => {
    const { shipping_data, changeShippingCarrierAction, order_id } = this.props
    const { transitRateConfirm } = this.state
    this.setState({saving: true, transitRateResult: null, transitRateConfirm: null})
    changeShippingCarrierAction(shipping_data.id, transitRateConfirm, order_id).catch(() => {
      this.setState({saving: false})
    })
  }

  closeTransitRateResult = () => {
    this.setState({transitRateResult: null, transitRateConfirm: null})
  }

  toggleEditMode = () => {
    const { editMode } = this.state
    this.setState({
      editMode: !editMode,
      extraRows: this.clearEmpty(),
      deleteRows: []
    })
  }

  clearEmpty(){
    const { extraRows } = this.state
    return extraRows.filter(p => (
      Array.from(document.querySelectorAll('[data-tmpid="'+p.tmpid+'"]')).some(i => (i.value !== ''))
    ))
  }

  newParcelRow = () => {
    const { shipping_data } = this.props
    const { newMode } = this.state
    const extraRows = this.clearEmpty()

    const defaultValues = newMode ?
      (extraRows && extraRows.length > 0) ? extraRows[0] : undefined
      :
      (shipping_data.shipping_parcels_ids || [])[0]
    this.setState({
      extraRows: [
        ...extraRows,
        {
          ...(defaultValues ? {...defaultValues, id: undefined } : {}),
          tmpid: `#${extraRows.length+1}`
        }
      ]
    })
  }

  removeParcel = (parcel) => {
    const id = parcel.id || parcel.tmpid
    if ((id + '').charAt(0) === '#') {
      this.setState(prevState => ({
        extraRows: prevState.extraRows.filter(p => p.tmpid !== id),
      }));
    } else {
      this.setState(prevState => ({
        deleteRows: [...prevState.deleteRows, id],
      }));
    }
  };

  getParcelInput = (parcel, field, options) => {
    //niezapisane pozycje, bez id
    let extraAttr = {}
    if(!parcel.id){
      extraAttr['data-tmpid'] = parcel.tmpid
    }

    if (typeof options !== 'undefined') {
      return (
        <select
          name={`${field}_${parcel.id}`}
          defaultValue={(parcel[field] && parcel[field][0]) || ''}
          data-parcel="1"
          {...extraAttr}
          onChange={(e) => this.handleParcelChange(e, parcel.tmpid || parcel.id, field)}
        >
          {options.map(opt => (
            <option key={opt[0]} value={opt[0]}>{opt[1]}</option>
          ))}
        </select>
      )
    }

    return (
      <input
        type="number"
        step="0.01"
        name={`${field}_${parcel.id}`}
        defaultValue={
          parcel[field] !== undefined
            ? (typeof parcel[field] === 'number'
              ? parcel[field].toFixed(2).replace(/[.,]00$/, "")
              : parcel[field])
            : '0'
        }
        data-parcel="1"
        {...extraAttr}
        onChange={(e) => this.handleParcelChange(e, parcel.tmpid || parcel.id, field)}
      />
    )
  }

  getParcelRow = (parcel, i) => {
    const { shipping_data } = this.props
    const { editMode } = this.state
    const sizes = shipping_data.sizes || []
    const types = shipping_data.types || []

    return (
      <tr key={parcel.id || parcel.tmpid} data-id={parcel.id || parcel.tmpid}>
        <td>{i + 1}{!parcel.id && '*'}</td>
        <td className="right">
          {(!editMode && parcel.weight && parcel.weight.toFixed(2).replace(/[.,]00$/, "")) || (
            this.getParcelInput(parcel, 'weight')
          )}
        </td>
        <td className="right">
          {(!editMode && (parcel.height || '')) || (
            this.getParcelInput(parcel, 'height')
          )}
        </td>
        <td className="right">
          {(!editMode && (parcel.length || '')) || (
            this.getParcelInput(parcel, 'length')
          )}
        </td>
        <td className="right">
          {(!editMode && (parcel.width || '')) || (
            this.getParcelInput(parcel, 'width')
          )}
        </td>
        <td className="right">
          {(!editMode && (parcel.size && parcel.size[1] || '')) ||
          (editMode && sizes.length > 0 && (
            this.getParcelInput(parcel, 'size', sizes)
          ))}
        </td>
        <td className="right">
          {(!editMode && (parcel.type_id && parcel.type_id[1] || '')) ||
          (editMode && types.length > 0 && (
            this.getParcelInput(parcel, 'type_id', types)
          ))}
        </td>
        <td className="right">
          {parcel.waybill || ''}
        </td>
        {editMode &&
          <td className="right">
            <button
              className="removeParcel"
              onClick={() => this.removeParcel(parcel)}
            >
            </button>
          </td>
        }
      </tr>
    )
  }

  renderField = (field, type, after) => {
    const { shipping_data } = this.props
    const { editMode } = this.state
    if(editMode){
      let inputProps = {
        name: field,
        defaultValue: shipping_data[field] || '',
        type: type==='float'?'number':'text'
      }
      if (type === 'float'){
        inputProps.step = '0.01'
      }
      return (
        <div>
          <input {...inputProps}/>
          {after || null}
        </div>
      )
    } else {
      return (
        <div>
          {shipping_data[field] || ''}
          {(shipping_data[field] || '') && (after || null)}
        </div>
      )
    }
  }


  renderOption = (option) => {
    const { shipping_data } = this.props
    const { editMode } = this.state
    const key = option.name
    //nowa przesylka: opcje przewoznika nie maja value, bierzemy wartosc z zamowienia
    const value = 'value' in option ? option.value : shipping_data[option.name]
    let input
    if(option.type === 'boolean'){
      input = <input type="checkbox"
                     name={option.name}
                     data-option="true"
                     defaultChecked={!!value}
                     disabled={!editMode}/>
    } else if(option.type === 'selection'){
      input = <select name={option.name}
                      data-option="true"
                      defaultValue={value || ''}
                      disabled={!editMode}>
        {option.choices.map(choice => (
          <option key={choice[0]} value={choice[0]}>{choice[1]}</option>
        ))}
      </select>
    } else {
      const number = option.type === 'number'
      input = <input type={number ? 'number' : (option.type === 'date' ? 'date' : 'text')}
                     step={number ? '0.01' : undefined}
                     name={option.name}
                     data-option="true"
                     defaultValue={value || ''}
                     disabled={!editMode}/>
    }
    return (
      <div className="f_group" key={key}>
        <label>{option.label}:</label>
        {input}
        {option.unit === 'currency' && <span> {shipping_data.currency_id}</span>}
      </div>
    )
  }

  carrierChange = (event) => {
    const selectedCarrierId = parseInt(event.target.value, 10);
    const { shipping_data } = this.props;

    const carriers = (shipping_data && shipping_data.carriers) || [];
    const selectedCarrier = carriers.find(c => c.id === selectedCarrierId);
    if (!selectedCarrier) return;

    const defaultParcels = selectedCarrier.default_parcels || [];
    const parcelsArray = Array.isArray(defaultParcels) ? defaultParcels : [defaultParcels];

    this.setState({
      selectedCarrier: selectedCarrierId,
      extraRows: addTmpIds(parcelsArray),
      newMode: true,
      transitRateExtraVals: {}
    });
  }

  getDefaultParcelFromSelectedCarrier = () => {
    const { shipping_data } = this.props;
    const { selectedCarrier } = this.state;
    const carriers = (shipping_data && shipping_data.carriers) || [];
    const carrier = carriers.find(c => c.id === selectedCarrier);
    const defaultParcels = carrier && carrier.default_parcels;
    const parcelsArray = Array.isArray(defaultParcels) ? defaultParcels : [defaultParcels];
    return addTmpIds(parcelsArray);
  };

  handleParcelChange = (event, parcelId, field) => {
    const value = event.target.value
    this.setState(prevState => {
      const newExtraRows = prevState.extraRows.map(p => {
        if ((p.id || p.tmpid) === parcelId) {
          return {
            ...p,
            [field]: field === 'weight' || field === 'height' || field === 'length' || field === 'width'
              ? parseFloat(value) || 0
              : value
          }
        }
        return p
      })
      return { extraRows: newExtraRows }
    })
  }

  render() {
    const { shipping_data } = this.props
    const {
      editMode, newMode, extraRows, deleteRows, selectedCarrier,
      transitRateResult, transitRateLoading, transitRateConfirm
    } = this.state
    let parcels = []
    let parcel_locker
    let options = []
    let showTransitRateButton = false;
    if (shipping_data) {
      if (!newMode) {
        parcels = shipping_data.shipping_parcels_ids || [];
      }

      parcel_locker = shipping_data.parcel_locker || false;
      options = shipping_data.options || []
      showTransitRateButton = !!shipping_data.show_transit_rate_on_packing_zone;

      if (selectedCarrier && Array.isArray(shipping_data.carriers)) {
        const carrierData = shipping_data.carriers.find(c => c.id === selectedCarrier);
        if (carrierData) {
          parcel_locker = carrierData.parcel_locker || false;
          options = carrierData.options || []
        }
      }
    }
    const transitRateButton = (
      <button
        className="secondary"
        onClick={this.handleFetchTransitRate}
        disabled={transitRateLoading}
        style={{position: 'absolute', top: '10px', left: '50%', transform: 'translateX(-50%)'}}
      >
        {transitRateLoading ? intl.get('Pobieranie stawek...') : intl.get('Sprawdź cenę tranzytu')}
      </button>
    )
    const currentCarrierId = newMode ? selectedCarrier : (transitRateResult && transitRateResult.current_carrier_id)
    return (
      <div id="root">
      <main>
        <div className="shipping_header">
          {newMode &&
            <>
              <button className="pull-left secondary" onClick={this.deselectShipping}>{intl.get('Anuluj')}</button>
              <button onClick={this.handleSubmit} className="pull-right" id="zatwierdz" >{intl.get('Zapisz')}</button>
              {showTransitRateButton && transitRateButton}
            </>
          }
          {editMode && !newMode &&
            <>
              <button className="pull-left secondary" onClick={this.toggleEditMode}>{intl.get('Anuluj')}</button>
              <button onClick={this.handleSubmit} className="pull-right" id="zatwierdz" >{intl.get('Zapisz')}</button>
              {showTransitRateButton && transitRateButton}
            </>
          }
          {!editMode && !newMode &&
            <>
              <button className="pull-left secondary" onClick={this.deselectShipping}>{intl.get('Wstecz')}</button>
              {!(shipping_data && shipping_data.waybill) &&
                <button onClick={this.toggleEditMode} className="pull-right" id="edytuj" >{intl.get('Edytuj')}</button>
              }
              {showTransitRateButton && transitRateButton}
            </>
          }
        </div>
        {(shipping_data) &&
          <div className="shipping pakowanie_content">
            <div className="row">
              <div className="col-sm-6">
                <h4>{intl.get('Przewoźnik')}</h4>
                <div className="f_group">
                  <label>{intl.get('Metoda dostawy')}:</label>
                  {newMode &&
                    <select name="carrier_id" onChange={this.carrierChange} value={this.state.selectedCarrier}>
                      {shipping_data.carriers.map(carrier => (
                        <option key={carrier.id} value={carrier.id}>{carrier.name}</option>
                      ))}
                    </select>
                  }
                  {!newMode && (
                    <div>{shipping_data.carrier_name}</div>
                  )}
                </div>
                <div className="f_group">
                  <label>{intl.get('List przewozowy')}:</label>
                  <div>{shipping_data.waybill}</div>
                </div>
                <div className="f_group">
                  <label>{intl.get('Data listu przewozowego')}:</label>
                  <div>{shipping_data.waybill_date}</div>
                </div>
                <div className="f_group">
                  <label>{intl.get('Link śledzenia')}:</label>
                  <div>
                    {shipping_data.tracking_url &&
                      <a target="_blank"
                         rel="noopener noreferrer"
                         href={shipping_data.tracking_url}>{shipping_data.tracking_url}</a>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <h4>{intl.get('Dane odbiorcy')}</h4>
                <div className="f_group">
                  <label>{intl.get('Nazwa')}:</label>
                  {this.renderField('receiver_name')}
                </div>
                <div className="f_group">
                  <label>{intl.get('Firma')}:</label>
                  {this.renderField('receiver_company')}
                </div>
                <div className="f_group">
                  <label>{intl.get('Ulica')}:</label>
                  {this.renderField('receiver_street')}
                </div>
                <div className="f_group">
                  <label>{intl.get('Miasto')}:</label>
                  {this.renderField('receiver_city')}
                </div>
                <div className="f_group">
                  <label>{intl.get('Kod pocztowy')}:</label>
                  {this.renderField('receiver_zip')}
                </div>
                <div className="f_group">
                  <label>{intl.get('Kraj')}:</label>
                  {editMode &&
                    <select name="receiver_country" defaultValue={shipping_data.countries.find(c => c[1] === shipping_data.receiver_country)[0]}>
                      {shipping_data.countries.map(country => (
                        <option key={country[0]} value={country[0]}>{country[1]}</option>
                      ))}
                    </select>
                  }
                  {!editMode && this.renderField('receiver_country')}
                </div>
                <div className="f_group">
                  <label>{intl.get('Email')}:</label>
                  {this.renderField('receiver_email')}
                </div>
                <div className="f_group">
                  <label>{intl.get('Telefon')}:</label>
                  {this.renderField('receiver_phone')}
                </div>
                <div className="f_group">
                  <label>{intl.get('Telefon komórkowy')}:</label>
                  {this.renderField('receiver_phone_mobile')}
                </div>
              </div>
              <div className="col-sm-6">
                <h4>{intl.get('Dane nadawcy')}</h4>
                <div className="f_group">
                  <label>{intl.get('Sklep')}:</label>
                  {newMode &&
                    <select name="shop_id" defaultValue={shipping_data.shop_id}>
                      {shipping_data.shops.map((shop) => (
                        <option key={shop[0]} value={shop[0]}>
                          {shop[1]}
                        </option>
                      ))}
                    </select>
                  }
                  {!newMode && (
                    <div>{shipping_data.shop}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <h4>{intl.get('Dane przesyłki')}</h4>
                { parcel_locker && (
                  <>
                    <div className="f_group">
                      <label>{intl.get('Punkt odbioru')}:</label>
                      {this.renderField('pickup_point_id')}
                    </div>
                    <div className="f_group">
                      <label>{intl.get('Ulica punktu odbioru')}:</label>
                      {this.renderField('pickup_point_street')}
                    </div>
                    <div className="f_group">
                      <label>{intl.get('Miasto punktu odbioru')}:</label>
                      {this.renderField('pickup_point_city')}
                    </div>
                    <div className="f_group">
                      <label>{intl.get('Kod pocztowy punktu odbioru')}:</label>
                      {this.renderField('pickup_point_zip')}
                    </div>
                  </>
                )}
                {options.map(this.renderOption)}

              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <h4>{intl.get('Paczki')}</h4>
                <table className="parcels table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th className="right">{intl.get('Waga')}</th>
                      <th className="right">{intl.get('Wysokość')}</th>
                      <th className="right">{intl.get('Długość')}</th>
                      <th className="right">{intl.get('Szerokość')}</th>
                      <th className="right">{intl.get('Rozmiar')}</th>
                      <th className="right">{intl.get('Typ')}</th>
                      <th className="right">{intl.get('List przewozowy')}</th>
                      {editMode &&
                        <th></th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {!newMode && parcels.filter(p => !deleteRows.includes(p.id))
                                                       .map((parcel, i) => this.getParcelRow(parcel, i))}
                    {extraRows.map((parcel, i) => this.getParcelRow(parcel, i+parcels.length-deleteRows.length))}
                  </tbody>
                </table>
                {editMode &&
                  <button className="addRow" onClick={this.newParcelRow}>{intl.get('Dodaj pozycję')}</button>
                }
              </div>
            </div>
          </div>
        }
        {transitRateResult &&
          <div
            role="presentation"
            onClick={this.closeTransitRateResult}
            style={{
              position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
              background: 'rgba(0, 0, 0, 0.5)', zIndex: 1000,
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}
          >
            <div
              role="presentation"
              onClick={(e) => e.stopPropagation()}
              style={{
                background: '#fff', width: '760px', maxWidth: '90vw', maxHeight: '80vh',
                display: 'flex', flexDirection: 'column',
                border: transitRateResult.error ? '1px solid red' : 'none'
              }}
            >
              <div style={{
                display: 'flex', justifyContent: 'flex-end',
                padding: '10px 15px', borderBottom: '1px solid #eee'
              }}>
                <button className="secondary" onClick={this.closeTransitRateResult}>
                  {intl.get('Zamknij')}
                </button>
              </div>
              <div style={{padding: '15px', overflow: 'auto'}}>
                {transitRateResult.error &&
                  <div style={{color: 'red', marginBottom: '10px', wordBreak: 'break-word'}}>{transitRateResult.error}</div>
                }
                {transitRateConfirm &&
                  <div style={{marginBottom: '10px', padding: '10px', border: '1px solid #eee'}}>
                    <div style={{marginBottom: '10px'}}>
                      {intl.get('Zmienić metodę dostawy na')} {transitRateConfirm.carrier_name}?
                    </div>
                    <button className="secondary" onClick={() => this.setState({transitRateConfirm: null})}>
                      {intl.get('Anuluj')}
                    </button>
                    <button className="pull-right" onClick={this.confirmTransitRate}>
                      {intl.get('Zmień')}
                    </button>
                  </div>
                }
                {!transitRateResult.error && transitRateResult.rates.length === 0 &&
                  <div>{intl.get('Brak dostępnych stawek')}</div>
                }
                {transitRateResult.rates.length > 0 &&
                  <table className="table" style={{width: '100%'}}>
                    <thead>
                      <tr>
                        <th>{intl.get('Metoda dostawy')}</th>
                        <th>{intl.get('Usługa')}</th>
                        <th>{intl.get('Cena')}</th>
                        <th>{intl.get('Dostawa')}</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {transitRateResult.rates.map((rate, index) => (
                        <tr
                          key={`${rate.carrier_id}-${index}`}
                          style={rate.carrier_id === currentCarrierId ? {fontWeight: 'bold'} : {}}
                        >
                          <td>{rate.carrier_name}</td>
                          <td>
                            {rate.service_name}
                            {(rate.messages || []).map((message, i) => (
                              <div key={i} style={{fontSize: '0.85em', color: '#888'}}>{message}</div>
                            ))}
                          </td>
                          {rate.error
                            ? <td colSpan={2} style={{color: '#c00', wordBreak: 'break-word'}}>{rate.error}</td>
                            : <>
                                <td style={{whiteSpace: 'nowrap'}}>{Number(rate.price).toFixed(2)} {rate.currency}</td>
                                <td>{[rate.delivery_days, rate.delivery_date].filter(Boolean).join(' / ')}</td>
                              </>
                          }
                          <td>
                            {!rate.error && rate.carrier_id &&
                              (rate.carrier_id !== currentCarrierId || Object.keys(rate.extra_vals || {}).length > 0) &&
                              <button className="secondary" onClick={() => this.selectTransitRate(rate)}>
                                {intl.get('Wybierz')}
                              </button>
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                }
              </div>
            </div>
          </div>
        }
      </main>
      </div>
    )
  }
}

const Shipping = connect(mapStateToProps, mapDispatchToProps)(ShippingComponent)

Popup.registerPlugin('shippingOrder', function (shipping_id, parent) {
    this.create({
        title: intl.get('Przesyłka'),
        className: 'big_popup',
        content: <Shipping shipping_id={shipping_id} parent={parent}/>
    })
})
